import config from '../envConfig';

export enum StoreBranches {
  Permissions = 'permissions',
  Global = 'global',
  Exercises = 'exercises',
}

export enum REDUX_CACHE {
  LIST = 'LIST',
  LAZY_LIST = 'LAZY_LIST',
  ABORT_INVALIDATION = 'ABORT',
}

export const HTTP_METHOD = {
  GET: 'GET',
  POST: 'POST',
  PUT: 'PUT',
  PATCH: 'PATCH',
  DELETE: 'DELETE',
};

const baseURL = config.apiBaseUrl;

export const constants = {
  baseURL,
};

export enum EXERCISE_PAGES {
  ALL = 'all',
  CREATED_BY_USER = 'createdByUser',
  FAVORITE = 'favorite',
  PUBLIC = 'public',
  AVAILABLE = 'available',
  AVAILABLE_DETAILED = 'availableDetailed',
  ALL_FOR_ADDING = 'allForAdding',
  APPROVE_REQUESTED = 'approveRequested',
  EXERCISE_RESULTS = 'exerciseResults',
  /** Single exercise by id (detail / GET by id) */
  EXERCISE_DETAIL = 'exerciseDetail',
}

export enum EXERCISE_CONFIG {
  EXERCISE_OPTIONS = 'exerciseOptions',
  EXERCISE_CATEGORIES = 'exerciseCategories',
}

export enum TRANSLATIONS {
  LANGUAGES = 'languages',
}

export enum PROGRAMS {
  PROGRAMS = 'programs',
  PROGRAM_ITEMS = 'programItems',
  PROGRAM_SETS = 'programSets',
  AVAILABLE = 'programsAvailable',
  EXERCISES = 'programItemExercises',
}

export enum TRAININGS {
  TRAININGS = 'trainings',
  TRAININGS_LAZY = 'trainingsLazy',
  TRAININGS_BY_DAY = 'trainingsByDay',
  TRAININGS_BY_PERIOD = 'trainingsByPeriod',
  TRAINING_ITEMS = 'trainingItems',
  AVAILABLE = 'programsAvailable',
  /** GET /trainings/created-for-others */
  CREATED_FOR_OTHERS = 'trainingsCreatedForOthers',
  EXERCISES = 'exercises',
  TRAININGS_FOR_ANALYTIC = 'trainingsForAnalytic',
  TRAINING_ACTIVITY_TYPES = 'trainingActivityTypes',
}

export enum CHATS {
  CHATS = 'chats',
  SELECTED_CHAT = 'selectedChat',
  UNREAD_MESSAGES = 'unreadMessages',
}

export enum COMMUNITIES {
  COMMUNITIES = 'communities',
  SELECTED_COMMUNITY = 'selectedCommunity',
  MY_COMMUNITIES = 'myCommunities',
}

export enum POSTS {
  POSTS = 'posts',
  NEWS = 'news',
}

export enum SEARCH {
  SEARCH = 'search',
}

export enum USERS {
  USERS = 'users',
  ME = 'me',
  ME_ONBOARDING = 'meOnboarding',
  ME_DETAILED = 'meDetailed',
  RESTRICTIONS = 'restrictions',
  PERMISSIONS = 'permissions',
  USER_COMMUNITIES = 'userCommunities',
  USER_SUBSCRIBERS = 'userSubscribers',
  USER_SUBSCRIBER_REQUESTS = 'userSubscriberRequests',
  REJECTED_USER_SUBSCRIBER_REQUESTS = 'rejectedUserSubscriberRequests',
  USER_SUBSCRIPTIONS = 'userSubscriptions',
  SELECTED_USER = 'selectedUser',
  RESTRICTION_PERMISSIONS = 'restrictionsPermissions',
  USER_TRAINING_ACCESS = 'userTrainingAccess',
}

export enum SUBSCRIPTIONS {
  PLANS = 'plans',
  RESTRICTIONS = 'restrictions',
}

export enum BUG_REPORTS {
  BUG_REPORT_TYPES = 'bugReportTypes',
  BUG_REPORT = 'bugReport',
  BUG_REPORTS = 'bugReports',
}

export enum APP_VARIABLES {
  APP_VARIABLE = 'appVariable',
  APP_VARIABLES = 'appVariables',
  APP_FEATURES = 'appFeatures',
  APP_FORMULAS = 'appFormulas',
}
